<template>
  <modal @close="$emit('close')">
    <template #body>
      <div class="re-inquiry">
        <div class="re-inquiry__title">{{ title }}</div>
        <div class="re-inquiry__sub">Мы свяжемся с вами в ближайшее время</div>

        <form class="re-inquiry__form" @submit.prevent="send">
          <div class="re-inquiry__row">
            <Input
              placeholder="Ваше имя *"
              type="text"
              class="input input-full"
              v-model="form.name"
            />
            <Input
              placeholder="Телефон *"
              type="tel"
              class="input input-full"
              v-model="form.phone"
            />
          </div>
          <Input
            placeholder="Email"
            type="email"
            class="input input-full"
            v-model="form.email"
          />
          <Textarea
            placeholder="Комментарий"
            class="input input-full"
            v-model="form.message"
          />

          <div v-if="error" class="re-inquiry__error">{{ error }}</div>
          <div v-if="success" class="re-inquiry__success">Заявка отправлена. Мы свяжемся с вами!</div>

          <Button
            :title="sending ? 'Отправка...' : 'Отправить заявку'"
            class="full-dark-btn"
            type="submit"
            :disabled="sending || success"
          />

          <div class="re-inquiry__consents">
            <label class="re-inquiry__consent">
              <input type="checkbox" v-model="agreePrivacy" />
              <span>Я соглашаюсь с <a href="/privacy" target="_blank">политикой обработки персональных данных</a></span>
            </label>
            <label class="re-inquiry__consent">
              <input type="checkbox" v-model="agreeOferta" />
              <span>Я принимаю <a href="/oferta" target="_blank">условия оферты</a></span>
            </label>
          </div>
          <LoginHint />
        </form>
      </div>
    </template>
  </modal>
</template>

<script setup lang="ts">
import LoginHint from "~/components/UI/LoginHint.vue";
import modal from '~/components/UI/Modal.vue'
import Input from '~/components/UI/inputs/Input.vue'
import Textarea from '~/components/UI/inputs/Textarea.vue'
import Button from '~/components/UI/btn/Button.vue'
import { RealEstateInquiryApi } from '~/api/RealEstate'

const props = defineProps<{
  title?: string
  objectId?: number | null
  projectId?: number | null
}>()

const emit = defineEmits(['close'])

const form = reactive({ name: '', phone: '', email: '', message: '' })
const agreePrivacy = ref(false)
const agreeOferta = ref(false)
const sending = ref(false)
const success = ref(false)
const error = ref('')

async function send() {
  error.value = ''
  if (!form.name.trim() || !form.phone.trim()) {
    error.value = 'Пожалуйста, заполните имя и телефон'
    return
  }
  if (!agreePrivacy.value || !agreeOferta.value) {
    error.value = 'Необходимо принять политику конфиденциальности и условия оферты'
    return
  }

  sending.value = true
  try {
    const data = new FormData()
    data.append('name', form.name.trim())
    data.append('phone', form.phone.trim())
    if (form.email.trim()) data.append('email', form.email.trim())
    if (form.message.trim()) data.append('message', form.message.trim())
    if (props.objectId) data.append('objectId', String(props.objectId))
    else if (props.projectId) data.append('projectId', String(props.projectId))

    await RealEstateInquiryApi.send(data)
    success.value = true
    setTimeout(() => emit('close'), 2000)
  } catch {
    error.value = 'Ошибка отправки. Попробуйте ещё раз.'
  } finally {
    sending.value = false
  }
}
</script>

<style scoped>
.re-inquiry { padding: 0.5rem 0; }

.re-inquiry__title {
  font-size: 2rem;
  font-weight: 500;
  margin-bottom: 0.6rem;
}

.re-inquiry__sub {
  font-size: 1.3rem;
  color: #888;
  margin-bottom: 2.4rem;
}

.re-inquiry__form {
  display: flex;
  flex-direction: column;
  gap: 1.4rem;
}

.re-inquiry__row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.2rem;
}
@media (max-width: 600px) {
  .re-inquiry__row { grid-template-columns: 1fr; }
}

.re-inquiry__consents {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  margin-top: 0.4rem;
}

.re-inquiry__consent {
  display: flex;
  align-items: flex-start;
  gap: 0.8rem;
  font-size: 1.1rem;
  color: #888;
  cursor: pointer;
  line-height: 1.4;
}

.re-inquiry__consent input[type="checkbox"] {
  margin-top: 2px;
  flex-shrink: 0;
  cursor: pointer;
}

.re-inquiry__consent a {
  color: #555;
  text-decoration: underline;
}

.re-inquiry__error {
  font-size: 1.2rem;
  color: #e33;
}

.re-inquiry__success {
  font-size: 1.2rem;
  color: #2a7a2a;
}
</style>
